import autoBind from 'auto-bind'

import { User, UserAddress } from 'api/domain/user'
import { ActionResult, Optional, CountriesParams } from 'api/domain/app'
import { AppApiBase } from 'api/core/AppApiBase'

export type SetUserBasicInfo = {
  first_name: string
  last_name: string
  username: Optional<string>
}

export class ProfileApi {
  constructor(protected api: AppApiBase) {
    autoBind(this)
  }

  async me() {
    const data = await this.api.get<User>('/users/me')
    return data.avatar ? { ...data, avatar: `${data.avatar}?${new Date().getTime()}` } : data
  }

  setBasicInfo(body: SetUserBasicInfo) {
    return this.api.patch<User>('/users/me', body)
  }

  async getCountries(params?: CountriesParams) {
    const data = await this.api.get<{ countries: { [key: string]: string } }>('/info/countries', {
      ...params,
    })

    return data
  }

  updateBillingInfo(body: UserAddress) {
    return this.api.patch<User>('/users/me', body)
  }

  uploadAvatar(photo: Blob) {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    const formData = new FormData()
    formData.append('file', photo)
    return this.api.put<ActionResult>('/profile/avatar', formData, config)
  }

  deleteAvatar() {
    return this.api.delete<ActionResult>('/profile/avatar')
  }

  changeEmailConfirm(body: { token: string }) {
    return this.api.post<ActionResult>('/profile/change_email_token_new', body)
  }
}
